
import {defineComponent, PropType} from "vue";
import {TradeContractFormat} from "@/store/modules/hcs/tradeContractFormat/model";
import FormatTable from "@/components/pages/contract/TradeContractFormat/FormatTable.vue";
import TradeContractFormatView, {
  createTradeContractFormatView
} from "@/components/pages/contract/TradeContractFormat/TradeContractFormatView";
import TableInline from "@/components/atoms/TableInline.vue";
import ReadonlyCheckbox from "@/components/atoms/ReadonlyCheckbox.vue";
import {mapActions} from "vuex";
import {MAX_TRADE_CONTRACT_FORMAT_COUNT} from "@/store/modules/hcs/tradeContractFormatGroup/model";

export default defineComponent({
  name: 'SelectFormatForm',
  components: {
    ReadonlyCheckbox, TableInline,
    FormatTable
  },
  inject: [
    'dialog'
  ],
  props: {
    value: {
      type: Array as PropType<TradeContractFormat[]>,
      required: true,
    },
  },
  data() {
    return {
      formats: [] as TradeContractFormat[],
      selectedIds: [] as string[],
    };
  },
  computed: {
    formatsView(): TradeContractFormatView[] {
      return this.formats.map(s => createTradeContractFormatView(s, this.$store));
    },
  },
  methods: {
    ...mapActions({
      fetchTradeContractFormats: "hcs/tradeContractFormat/findList",
    }),
    async load() {
      this.formats = await this.fetchTradeContractFormats();
    },
    handleSelectedChange(row: TradeContractFormat, isSelected: boolean) {
      const index = this.selectedIds.findIndex(s => row.id === s);
      if(isSelected && index === -1 && this.selectedIds.length < MAX_TRADE_CONTRACT_FORMAT_COUNT) {
        this.selectedIds.push(row.id);
      } else if(!isSelected && index !== -1) {
        this.selectedIds.splice(index, 1);
      }

      const selection = this.formats.filter(f => this.selectedIds.includes(f.id));
      this.$emit('input', selection);
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(selection: TradeContractFormat[]) {
        this.selectedIds = selection?.map(s => s.id) ?? [];
      }
    },
    'dialog.visible': {
      immediate: true,
      handler() {
        if (this.dialog === null || this.dialog.visible) {
          this.load();
        }
      }
    }
  }
});
